module.exports = __webpack_public_path__ + "media/images/icons/Hvezdicky/starEmpty@2x-83fd16046f96ec16dd6487448a7c3128.png";